
import { handleActions } from 'redux-actions'
import {
  routeToOnDemand,
  routeToInstalledAgent,
  routeToClassroomAgent,
} from './../actions/routing'
import { AGENT_TYPE } from './../actions/agent'

const initialState = {
  type: null,
  unattended: null,
}

export const agentReducer = handleActions({
  [routeToOnDemand] (prevState) {
    return {
      ...prevState,
      type: AGENT_TYPE.ON_DEMAND,
      unattended: false,
    }
  },
  [routeToInstalledAgent] (prevState) {
    return {
      ...prevState,
      type: AGENT_TYPE.INSTALLED_AGENT,
      unattended: true,
    }
  },
  [routeToClassroomAgent] (prevState) {
    return {
      ...prevState,
      type: AGENT_TYPE.CLASSROOM_AGENT,
      unattended: true,
    }
  },
}, initialState)
